import { useQuery } from '@tanstack/react-query';
import { getVerificationProfile } from '../requests';
import { useSessionStore } from '@/entities/session';

const useVerificationProfile = () => {
  const { session } = useSessionStore();
  const { data, isLoading, error } = useQuery({
    queryKey: ['user-verification-profile', session?.userId],
    queryFn: getVerificationProfile,
    staleTime: Infinity,
    enabled: !!session?.userId,
  });

  return {
    userVerificationProfile: data,
    isUserVerificationProfileLoading: isLoading,
    userVerificationProfileError: error,
  };
};

export { useVerificationProfile };
